import { render, staticRenderFns } from "./Inintroduce.vue?vue&type=template&id=b5bbb0ec&scoped=true"
import script from "./Inintroduce.vue?vue&type=script&lang=js"
export * from "./Inintroduce.vue?vue&type=script&lang=js"
import style0 from "./Inintroduce.vue?vue&type=style&index=0&id=b5bbb0ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bbb0ec",
  null
  
)

export default component.exports